// This page is currently a mini-app inject within the Rails page
// In the future, this component can take over the full page load

import React from 'react';
import StoryContent from '../components/textEditor/StoryContent';

export default function(props) {
  // eslint-disable-next-line react/destructuring-assignment
  const { storyId } = JSON.parse(props.appData);
  return <StoryContent storyId={storyId} readOnlyMode />;
}



// WEBPACK FOOTER //
// ./app/javascript/client/pages/ShowPage.jsx